import React from 'react';
import { FormattedMessage } from 'react-intl';
import "./footer.css";

export const FooterComponent = () => {
    return (
        <footer>
            <div className="container">
                <div className="row text-center text-md-left">
                    <div className="col-md-4 pt-4 px-2 text-center">
                        <h4 className="text-uppercase" data-aos="fade-up">
                            <FormattedMessage id="footer.rrss" />
                        </h4>
                        <ul data-aos="fade-up" data-aos-duration="1000">
                            <li>
                                <a href="https://www.instagram.com/openuchile.eol/" target="_blank" rel="noreferrer">
                                    <i className="fa fa-instagram mx-2 fa-2x"></i>
                                </a>
                                <a href="https://www.youtube.com/@educaciononlineuchile" target="_blank" rel="noreferrer">
                                    <i className="fa fa-youtube mx-2 fa-2x"></i>
                                </a>
                                <a href="https://www.linkedin.com/company/open-uchile/posts/?feedView=all" target="_blank" rel="noreferrer">
                                    <i className="fa fa-linkedin mx-2 fa-2x"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-4 pt-4 px-2 text-center">
                        <h4 className="text-uppercase" data-aos="fade-up">
                            <FormattedMessage id="footer.platforms" />
                        </h4>
                        <ul data-aos="fade-up" data-aos-duration="1000">
                            <li><a href="https://eol.uchile.cl/" target="_blank" rel="noreferrer">Educación Online (EOL)</a></li>
                            <li><a href="https://open.uchile.cl/" target="_blank" rel="noreferrer">Open UChile</a></li>
                        </ul>
                    </div>
                    <div className="col-md-4 pt-4 px-2 text-center">
                        <h4 className="text-uppercase" data-aos="fade-up">
                            <FormattedMessage id="footer.contact" />
                        </h4>
                        <ul data-aos="fade-up" data-aos-duration="1000">
                                <table>
                                    <tbody>
                                        <tr className="mb-2">
                                            <td className="pr-2"><i className="fas fa-map-marker-alt mx-auto"></i></td>
                                            <td>Diagonal Paraguay 265, Torre 15,<br/>Oficina 2003, Santiago, Chile</td>
                                        </tr>
                                        <tr className="mb-2">
                                            <td className="pr-2"><i className="far fa-envelope mx-auto"></i></td>
                                            <td><a href="mailto:eol-ayuda@uchile.cl" target="_blank" rel="noreferrer">eol-ayuda@uchile.cl</a></td>
                                        </tr>
                                        <tr className="mb-2">
                                            <td className="pr-2"><i className="far fa-calendar-alt mx-auto"></i></td>
                                            <td>
                                                <FormattedMessage id="footer.schedule_1" />
                                                <br/>
                                                <FormattedMessage id="footer.schedule_2" /></td>
                                        </tr>
                                    </tbody>
                                </table>
                        </ul>
                    </div>
                    <div className="col-12 mt-2 text-center">
                        <img
                            src="/images/logo-eol-white.png"
                            alt="Oficina de Educación Online Universidad de Chile"
                            className="img-fluid"
                            data-aos="zoom-in" data-aos-duration="1000"
                        />
                        <p className="copyright text-center"><FormattedMessage id="footer.copyright" /></p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
